import { DATE_FORMATS, secondsToDate } from '~/utils/dateFormat'

export const useTimeChartDateFormat = (data: [number, string][]) => {

  const xAxisData = data.map((item) => `${secondsToDate(item[0], DATE_FORMATS.dateOnly, 'utc')} (UTC)`)
  const yAxisData = data.map((item) => item[1])

  return { xAxisData, yAxisData }
}